export default class Datos3Drender {
  constructor() {
    return {
      colecciones: [
        {
          idclase: "SENNA",
          idcoleccion: "SENA",
          idcoleccionOLD: "SEN",
        },
        {
          idclase: "QUITO",
          idcoleccionOLD: "QUI",
        },
        {
          idclase: "DANUBIO",
          idcoleccionOLD: "DAN",
        },
        {
          idclase: "BOGOTA",
          idcoleccionOLD: "BOG",
        },
        {
          idclase: "ROMA",
          idcoleccionOLD: "ROM",
        },
        {
          idclase: "FLORIDA",
          idcoleccionOLD: "FLD",
        },
        {
          idclase: "VARSOVIA",
          idcoleccionOLD: "VAR",
        },
        {
          idclase: "VANCOUVER",
          idcoleccionOLD: "VAN",
        },
        {
          idclase: "QUEBEC",
          idcoleccionOLD: "QUE",
        },
        {
          idclase: "LONDRES",
          idcoleccionOLD: "LON",
        },
        {
          idclase: "MIAMI",
          idcoleccionOLD: "MIA",
        },
        {
          idclase: "EDIMBURGO",
          idcoleccionOLD: "EDI",
        },
        {
          idclase: "DELHI",
          idcoleccion: "MERIDA",
          idcoleccionOLD: "MRD",
        },
        {
          idclase: "RABAT",
          idcoleccion: "TOVAR",
          idcoleccionOLD: "TOV",
        },
        {
          idclase: "PEKIN",
          idcoleccion: "OLIMPIA",
          idcoleccionOLD: "OLI",
        },
        {
          idclase: "RODAS",
          idcoleccionOLD: "ROD",
        },
        {
          idclase: "ADELAIDA",
          idcoleccionOLD: "ADE",
        },
        {
          idclase: "CATANIA",
          idcoleccionOLD: "CAT",
        },
        {
          idclase: "POSITANO",
          idcoleccionOLD: "POS",
        },
        {
          idclase: "TRENTO",
          idcoleccionOLD: "TRE",
        },
        {
          idclase: "MESINA",
          idcoleccionOLD: "MES",
        },
        {
          idclase: "NAZCA",
          idcoleccionOLD: "NAZ",
        },
        {
          idclase: "ORLANDO",
          idcoleccionOLD: "ORL",
        },
        {
          idclase: "ABUDABI",
          idcoleccion: "ABU DABI",
          idcoleccionOLD: "ABU",
        },
        {
          idclase: "SAOPAULO",
          idcoleccionOLD: "SAO",
        },
        {
          idclase: "CHICAGO",
          idcoleccion: "ESPARTA",
          idcoleccionOLD: "ESP",
        },
        {
          idclase: "GARONA",
          idcoleccionOLD: "GAR",
        },
        {
          idclase: "GUADIANA",
          idcoleccionOLD: "GUA",
        },
        {
          idclase: "MISURI",
          idcoleccionOLD: "MIS",
        },
      ],
      language: [
        {
          1: "es",
          2: "en",
          3: "fr",
          4: "de",
          5: "it",
          6: "pt",
        },
      ],
      gruposCampos: [
        {
          grupo: "MEDIDAS",
          visual: "NO",
          includes: [
            "ALTURA",
            "MEDIDAS",
            "altura",
            "frontal",
            "LI",
            "LD",
            "lateralIzquierdo",
            "lateralDerecho",
            "lateralFijo",
            "LATERAL",
            "ANCHO_PUERTA",
            "ANCHO_FIJO",
            "PARCIAL_ALTO_MURO",
            "ANCHO_BANDERA",
            "FIJO_INTERIOR",
            "MEDIDA_HUECO",
            "FONDO_PLATO",
          ],
        },
        {
          grupo: "VIDRIO",
          visual: "NO",
          includes: ["ACABADO", "ESPESOR", "ANTICAL"],
        },
        {
          grupo: "PERFIL",
          visual: "NO",
          includes: ["N_RAL", "PIEZAS"],
        },
        {
          grupo: "TIRADOR",
          visual: "NO",
          includes: [],
        },
        {
          grupo: "ADICIONALES",
          visual: "NO",
          includes: [
            "POSICION",
            "POS_F_FRONTAL_ST",
            "HOJA_EXTERIOR",
            "posicionFijo",
            "POS_F_LATERAL_ST",
            "COGIDA",
            "SISTEMA_SUJECCION",
            "CIERRE_CON_IMAN",
            "VIERTEAGUAS",
            "PLATOELEVADOORASDESUELO",
            "CIERRE_CON_BURBUJA",
            "PUNTA_ROMA",
            "APERTURA",
            "PERFIL_ESCUADRA",
            "SISTEMA_SUJECCION",
            "ARMARIO_STC",
            "REPISA",
            "CERR_ABIE",
            "POS_F_BISAGRA",
            "POS_FIJOS_EXTRA",
            "ARMARIO_STC",
            "TIPO_CURVA",
            "PERFILERIA_ECO",
            "GUIA_DOBLE",
            "CIERRE_PARED",
            "INVERTIDA",
            "N_FIJOS",
            "UNIDADES_DE_ESPEJOS",
            "OPCIONES_MINDANAO",
            "FIJO_EXISTENTE_SI",
            "TIPO_CIERRE",
          ],
        },
        {
          grupo: "MONTAJE",
          visual: "NO",
          includes: ["MONTAJE", "montaje"],
        },
        {
          grupo: "VIDRIO",
          visual: "SI",
          includes: [
            "TIPO_VIDRIO",
            "DECORADO",
            "MATERIAL",
            "vidrio",
            "ACRILICO",
          ],
        },
        {
          grupo: "PERFIL",
          visual: "SI",
          includes: ["COLOR_PERFIL", "perfil"],
        },
        {
          grupo: "TIRADOR",
          visual: "SI",
          includes: ["POMO", "tirador"],
        },
        {
          grupo: "MEDIDAS",
          visual: "SI",
          includes: [],
        },
      ],
      gruposTrad: [
        {
          grupo: "VIDRIO",
          orden: 2,
          literales: [
            {
              codIdioma: "orden",
              texto: 2,
            },
            {
              codIdioma: "es",
              texto: "Vidrio",
            },
            {
              codIdioma: "en",
              texto: "Glass",
            },
            {
              codIdioma: "fr",
              texto: "Verre",
            },
            {
              codIdioma: "de",
              texto: "Glas",
            },
            {
              codIdioma: "it",
              texto: "Vetro",
            },
            {
              codIdioma: "pt",
              texto: "Vidro",
            },
          ],
        },
        {
          grupo: "PERFIL",
          orden: 3,
          literales: [
            {
              codIdioma: "orden",
              texto: 3,
            },
            {
              codIdioma: "es",
              texto: "Perfil",
            },
            {
              codIdioma: "en",
              texto: "Profile",
            },
            {
              codIdioma: "fr",
              texto: "Profilé",
            },
            {
              codIdioma: "de",
              texto: "Profil",
            },
            {
              codIdioma: "it",
              texto: "Profilo",
            },
            {
              codIdioma: "pt",
              texto: "Perfil",
            },
          ],
        },
        {
          grupo: "TIRADOR",
          orden: 4,
          literales: [
            {
              codIdioma: "orden",
              texto: 4,
            },
            {
              codIdioma: "es",
              texto: "Tirador",
            },
            {
              codIdioma: "en",
              texto: "Handle",
            },
            {
              codIdioma: "fr",
              texto: "Poignée",
            },
            {
              codIdioma: "de",
              texto: "Griff",
            },
            {
              codIdioma: "it",
              texto: "Maniglia",
            },
            {
              codIdioma: "pt",
              texto: "Puxador",
            },
          ],
        },
        {
          grupo: "MEDIDAS",
          orden: 1,
          literales: [
            {
              codIdioma: "orden",
              texto: 1,
            },
            {
              codIdioma: "es",
              texto: "Medidas",
            },
            {
              codIdioma: "en",
              texto: "Measurements",
            },
            {
              codIdioma: "fr",
              texto: "Mesures",
            },
            {
              codIdioma: "de",
              texto: "Maße",
            },
            {
              codIdioma: "it",
              texto: "Misure",
            },
            {
              codIdioma: "pt",
              texto: "Medidas",
            },
          ],
        },
        {
          grupo: "REVESTIMIENTO",
          orden: 6,
          literales: [
            {
              codIdioma: "orden",
              texto: 6,
            },
            {
              codIdioma: "es",
              texto: "Revestimiento",
            },
            {
              codIdioma: "en",
              texto: "Coating",
            },
            {
              codIdioma: "fr",
              texto: "Revêtement",
            },
            {
              codIdioma: "de",
              texto: "Beschichtung",
            },
            {
              codIdioma: "it",
              texto: "Rivestimento",
            },
            {
              codIdioma: "pt",
              texto: "Revestimento",
            },
          ],
        },
        {
          grupo: "OTROS",
          orden: 8,
          literales: [
            {
              codIdioma: "orden",
              texto: 8,
            },
            {
              codIdioma: "es",
              texto: "Otros",
            },
            {
              codIdioma: "en",
              texto: "Other",
            },
            {
              codIdioma: "fr",
              texto: "Autres",
            },
            {
              codIdioma: "de",
              texto: "Andere",
            },
            {
              codIdioma: "it",
              texto: "Altro",
            },
            {
              codIdioma: "pt",
              texto: "Outros",
            },
          ],
        },
        {
          grupo: "ADICIONALES",
          orden: 5,
          literales: [
            {
              codIdioma: "orden",
              texto: 5,
            },
            {
              codIdioma: "es",
              texto: "Características Adicionales",
            },
            {
              codIdioma: "en",
              texto: "Additional Features",
            },
            {
              codIdioma: "fr",
              texto: "Fonctionnalités supplémentaires",
            },
            {
              codIdioma: "de",
              texto: "Zusätzliche Funktionen",
            },
            {
              codIdioma: "it",
              texto: "Caratteristiche aggiuntive",
            },
            {
              codIdioma: "pt",
              texto: "Recursos Adicionais",
            },
          ],
        },
        {
          grupo: "MONTAJE",
          orden: 7,
          literales: [
            {
              codIdioma: "orden",
              texto: 7,
            },
            {
              codIdioma: "es",
              texto: "Montaje",
            },
            {
              codIdioma: "en",
              texto: "Installation",
            },
            {
              codIdioma: "fr",
              texto: "Montage",
            },
            {
              codIdioma: "de",
              texto: "Montage",
            },
            {
              codIdioma: "it",
              texto: "Montaggio",
            },
            {
              codIdioma: "pt",
              texto: "Montagem",
            },
          ],
        },
      ],
      revestimiento: [
        {
          campo: "SUELO",
          ces: "Suelo",
          cen: "Floor",
          cfr: "Sol",
          cde: "Boden",
          cit: "Pavimento",
          cpt: "Piso",
          acabado: "PARKET",
          aes: "Parquet",
          aen: "Parquet",
          afr: "Parquet",
          ade: "Parkett",
          ait: "Parquet",
          apt: "Parquet",
        },
        {
          acabado: "AZULEJO",
          aes: "Azulejo",
          aen: "Tile",
          afr: "Carreau",
          ade: "Fliese",
          ait: "Piastrella",
          apt: "Azulejo",
        },
        {
          acabado: "HORMIGON",
          aes: "Hormigón",
          aen: "Concrete",
          afr: "Béton",
          ade: "Beton",
          ait: "Cemento",
          apt: "Concreto",
        },
        {
          campo: "PARED",
          ces: "Pared",
          cen: "Wall",
          cfr: "Mur",
          cde: "Wand",
          cit: "Parete",
          cpt: "Parete",
          acabado: "CLARO",
          aes: "Claro",
          aen: "Light",
          afr: "Clair",
          ade: "Hell",
          ait: "Chiaro",
          apt: "Claro",
        },
        {
          acabado: "MEDIO",
          aes: "Medio",
          aen: "Medium",
          afr: "Moyen",
          ade: "Mittel",
          ait: "Medio",
          apt: "Médio",
        },
        {
          acabado: "OSCURO",
          aes: "Oscuro",
          aen: "Dark",
          afr: "Foncé",
          ade: "Dunkel",
          ait: "Scuro",
          apt: "Escuro",
        },
      ],
      positions: [
        {
          grupo: "VIDRIO",
          "QUITO.left": 0.68,
          "QUITO.top": 0.3,
          "RIMINI.left": 0.8,
          "RIMINI.top": 0.3,
          "JANEIRO.left": 0.85,
          "JANEIRO.top": 0.3,
          "SENNA.left": 0.68,
          "SENNA.top": 0.3,
          "BOGOTA.left": 0.39,
          "BOGOTA.top": 0.3,
          "DANUBIO.left": 0.66,
          "DANUBIO.top": 0.3,
          "ABUDABI.left": 0.71,
          "ABUDABI.top": 0.27,
          "CANCUN.left": 0.71,
          "CANCUN.top": 0.27,
          "FLORIDA.left": 0.68,
          "FLORIDA.top": 0.3,
          "GARONA.left": 0.71,
          "GARONA.top": 0.27,
          "GUADIANA.left": 0.6,
          "GUADIANA.top": 0.3,
          "IGUAZU.left": 0.66,
          "IGUAZU.top": 0.3,
          "MISURI.left": 0.68,
          "MISURI.top": 0.3,
          "ROMA.left": 0.68,
          "ROMA.top": 0.3,
          "VARSOVIA.left": 0.6,
          "VARSOVIA.top": 0.3,
          "VANCOUVER.left": 0.6,
          "VANCOUVER.top": 0.25,
          "QUEBEC.left": 0.6,
          "QUEBEC.top": 0.25,
          "LONDRES.left": 0.66,
          "LONDRES.top": 0.3,
          "SAOPAULO.left": 0.66,
          "SAOPAULO.top": 0.3,
          "PEKIN.left": 0.66,
          "PEKIN.top": 0.3,
          "RODAS.left": 0.26,
          "RODAS.top": 0.36,
          "ADELAIDA.left": 0.6,
          "ADELAIDA.top": 0.4,
          "CATANIA.left": 0.6,
          "CATANIA.top": 0.4,
          "TRENTO.left": 0.6,
          "TRENTO.top": 0.4,
          "MESINA.left": 0.6,
          "MESINA.top": 0.4,
          "POSITANO.left": 0.85,
          "POSITANO.top": 0.3,
          "NAZCA.left": 0.55,
          "NAZCA.top": 0.3,
          "CIXI.left": 0.68,
          "CIXI.top": 0.3,
          "YAKARTA.left": 0.76,
          "YAKARTA.top": 0.27,
          "BAGDAD.left": 0.68,
          "BAGDAD.top": 0.3,
          "KABUL.left": 0.66,
          "KABUL.top": 0.3,
          "KOBE.left": 0.83,
          "KOBE.top": 0.3,
          "BRUNEI.left": 0.66,
          "BRUNEI.top": 0.3,
          "SURIN.left": 0.68,
          "SURIN.top": 0.3,
          "NASSAU.left": 0.68,
          "NASSAU.top": 0.3,
          "BALI.left": 0.68,
          "BALI.top": 0.3,
          "SHANGHAI.left": 0.85,
          "SHANGHAI.top": 0.3,
          "ACAPULCO.left": 0.71,
          "ACAPULCO.top": 0.3,
          "DOHA.left": 0.26,
          "DOHA.top": 0.36,
          "FRANKFURT.left": 0.71,
          "FRANKFURT.top": 0.27,
          "ORLANDO.left": 0.39,
          "ORLANDO.top": 0.3,
          "BOSTON.left": 0.6,
          "BOSTON.top": 0.4,
          "PERTH.left": 0.68,
          "PERTH.top": 0.3,
          "BORNEO.left": 0.68,
          "BORNEO.top": 0.3,
          "CHICAGO.left": 0.6,
          "CHICAGO.top": 0.25,
          "NICOSIA.left": 0.66,
          "NICOSIA.top": 0.3,
          "EDIMBURGO.left": 0.66,
          "EDIMBURGO.top": 0.3,
          "MEDELLIN.left": 0.71,
          "MEDELLIN.top": 0.45,
          "BARRANQUILLA.left": 0.6,
          "BARRANQUILLA.top": 0.4,
          "ANKARA.left": 0.66,
          "ANKARA.top": 0.3,
          MONTREALleft: 0.71,
          "MONTREAL.top": 0.27,
          "TORONTO.left": 0.64,
          "TORONTO.top": 0.3,
          "ATLANTA.left": 0.6,
          "ATLANTA.top": 0.3,
          "MIAMI.left": 0.39,
          "MIAMI.top": 0.3,
          "BAHIA.left": 0.39,
          "BAHIA.top": 0.3,
          "DALLAS.left": 0.71,
          "DALLAS.top": 0.27,
          "SIAN.left": 0.6,
          "SIAN.top": 0.4,
          "MINDANAO.left": 0.6,
          "MINDANAO.top": 0.4,
          "DELHI.left": 0.66,
          "DELHI.top": 0.3,
          "RABAT.left": 0.6,
          "RABAT.top": 0.4,
          "MONTREAL.left": 0.71,
          "MONTREAL.top_1": 0.27,
        },
        {
          grupo: "PERFIL",
          "QUITO.left": 0.47,
          "QUITO.top": 0.15,
          "RIMINI.left": 0.69,
          "RIMINI.top": 0.12,
          "JANEIRO.left": 0.66,
          "JANEIRO.top": 0.12,
          "SENNA.left": 0.5,
          "SENNA.top": 0.09,
          "BOGOTA.left": 0.48,
          "BOGOTA.top": 0.08,
          "DANUBIO.left": 0.51,
          "DANUBIO.top": 0.13,
          "ABUDABI.left": 0.63,
          "ABUDABI.top": 0.05,
          "CANCUN.left": 0.64,
          "CANCUN.top": 0.15,
          "FLORIDA.left": 0.54,
          "FLORIDA.top": 0.1,
          "GARONA.left": 0.59,
          "GARONA.top": 0.1,
          "GUADIANA.left": 0.52,
          "GUADIANA.top": 0.15,
          "IGUAZU.left": 0.58,
          "IGUAZU.top": 0.14,
          "MISURI.left": 0.52,
          "MISURI.top": 0.15,
          "ROMA.left": 0.53,
          "ROMA.top": 0.13,
          "VARSOVIA.left": 0.45,
          "VARSOVIA.top": 0.14,
          "VANCOUVER.left": 0.47,
          "VANCOUVER.top": 0.14,
          "QUEBEC.left": 0.45,
          "QUEBEC.top": 0.12,
          "LONDRES.left": 0.55,
          "LONDRES.top": 0.12,
          "SAOPAULO.left": 0.55,
          "SAOPAULO.top": 0.12,
          "PEKIN.left": 0.6,
          "PEKIN.top": 0.12,
          "RODAS.left": 0.43,
          "RODAS.top": 0.08,
          "ADELAIDA.left": 0.53,
          "ADELAIDA.top": 0.14,
          "CATANIA.left": 0.53,
          "CATANIA.top": 0.14,
          "TRENTO.left": 0.57,
          "TRENTO.top": 0.14,
          "MESINA.left": 0.47,
          "MESINA.top": 0.11,
          "POSITANO.left": 0.56,
          "POSITANO.top": 0.14,
          "NAZCA.left": 0.51,
          "NAZCA.top": 0.13,
          "CIXI.left": 0.54,
          "CIXI.top": 0.15,
          "YAKARTA.left": 0.88,
          "YAKARTA.top": 0.15,
          "BAGDAD.left": 0.53,
          "BAGDAD.top": 0.13,
          "KABUL.left": 0.55,
          "KABUL.top": 0.12,
          "KOBE.left": 0.66,
          "KOBE.top": 0.12,
          "BRUNEI.left": 0.55,
          "BRUNEI.top": 0.12,
          "SURIN.left": 0.53,
          "SURIN.top": 0.13,
          "NASSAU.left": 0.51,
          "NASSAU.top": 0.1,
          "BALI.left": 0.47,
          "BALI.top": 0.15,
          "SHANGHAI.left": 0.66,
          "SHANGHAI.top": 0.12,
          "ACAPULCO.left": 0.55,
          "ACAPULCO.top": 0.07,
          "DOHA.left": 0.43,
          "DOHA.top": 0.08,
          "FRANKFURT.left": 0.59,
          "FRANKFURT.top": 0.1,
          "ORLANDO.left": 0.48,
          "ORLANDO.top": 0.08,
          "BOSTON.left": 0.47,
          "BOSTON.top": 0.11,
          "PERTH.left": 0.54,
          "PERTH.top": 0.1,
          "BORNEO.left": 0.54,
          "BORNEO.top": 0.1,
          "CHICAGO.left": 0.47,
          "CHICAGO.top": 0.14,
          "NICOSIA.left": 0.51,
          "NICOSIA.top": 0.13,
          "EDIMBURGO.left": 0.51,
          "EDIMBURGO.top": 0.13,
          "MEDELLIN.left": 0.47,
          "MEDELLIN.top": 0.11,
          "BARRANQUILLA.left": 0.47,
          "BARRANQUILLA.top": 0.11,
          "ANKARA.left": 0.55,
          "ANKARA.top": 0.12,
          MONTREALleft: 0.64,
          "MONTREAL.top": 0.15,
          "TORONTO.left": 0.51,
          "TORONTO.top": 0.13,
          "ATLANTA.left": 0.55,
          "ATLANTA.top": 0.24,
          "MIAMI.left": 0.48,
          "MIAMI.top": 0.08,
          "BAHIA.left": 0.48,
          "BAHIA.top": 0.08,
          "DALLAS.left": 0.59,
          "DALLAS.top": 0.1,
          "SIAN.left": 0.47,
          "SIAN.top": 0.11,
          "MINDANAO.left": 0.47,
          "MINDANAO.top": 0.11,
          "DELHI.left": 0.51,
          "DELHI.top": 0.13,
          "RABAT.left": 0.53,
          "RABAT.top": 0.14,
          "MONTREAL.left": 0.59,
          "MONTREAL.top_1": 0.1,
        },
        {
          grupo: "TIRADOR",
          "QUITO.left": 0.494,
          "QUITO.top": 0.43,
          "RIMINI.left": 0.67,
          "RIMINI.top": 0.42,
          "JANEIRO.left": 0.85,
          "JANEIRO.top": 0.43,
          "SENNA.left": 0.53,
          "SENNA.top": 0.43,
          "BOGOTA.left": 0.32,
          "BOGOTA.top": 0.47,
          "DANUBIO.left": 0.7,
          "DANUBIO.top": 0.41,
          "ABUDABI.left": 0.64,
          "ABUDABI.top": 0.4,
          "CANCUN.left": 0.75,
          "CANCUN.top": 0.42,
          "FLORIDA.left": 0.833,
          "FLORIDA.top": 0.42,
          "GARONA.left": 0.74,
          "GARONA.top": 0.42,
          "GUADIANA.left": 0.67,
          "GUADIANA.top": 0.43,
          "IGUAZU.left": 0.73,
          "IGUAZU.top": 0.43,
          "MISURI.left": 0.705,
          "MISURI.top": 0.43,
          "ROMA.left": 0.8,
          "ROMA.top": 0.41,
          "VARSOVIA.left": 0.6,
          "VARSOVIA.top": 0.4,
          "VANCOUVER.left": 0.75,
          "VANCOUVER.top": 0.5,
          "QUEBEC.left": 0.52,
          "QUEBEC.top": 0.48,
          "LONDRES.left": 0.55,
          "LONDRES.top": 0.48,
          "SAOPAULO.left": 0.55,
          "SAOPAULO.top": 0.48,
          "PEKIN.left": 0.64,
          "PEKIN.top": 0.48,
          "RODAS.left": 0.41,
          "RODAS.top": 0.45,
          "ADELAIDA.left": 0.75,
          "ADELAIDA.top": 0.5,
          "CATANIA.left": 0.55,
          "CATANIA.top": 0.45,
          "TRENTO.left": 0.74,
          "TRENTO.top": 0.47,
          "MESINA.left": 0.71,
          "MESINA.top": 0.43,
          "POSITANO.left": 0.72,
          "POSITANO.top": 0.44,
          "NAZCA.left": 0.5,
          "NAZCA.top": 0.41,
          "CIXI.left": 0.55,
          "CIXI.top": 0.43,
          "YAKARTA.left": 0.75,
          "YAKARTA.top": 0.42,
          "BAGDAD.left": 0.8,
          "BAGDAD.top": 0.41,
          "KABUL.left": 0.55,
          "KABUL.top": 0.46,
          "KOBE.left": 0.83,
          "KOBE.top": 0.43,
          "BRUNEI.left": 0.65,
          "BRUNEI.top": 0.43,
          "SURIN.left": 0.7,
          "SURIN.top": 0.43,
          "NASSAU.left": 0.7,
          "NASSAU.top": 0.44,
          "BALI.left": 0.64,
          "BALI.top": 0.44,
          "SHANGHAI.left": 0.85,
          "SHANGHAI.top": 0.43,
          "ACAPULCO.left": 0.56,
          "ACAPULCO.top": 0.42,
          "DOHA.left": 0.32,
          "DOHA.top": 0.45,
          "FRANKFURT.left": 0.74,
          "FRANKFURT.top": 0.42,
          "ORLANDO.left": 0.32,
          "ORLANDO.top": 0.47,
          "BOSTON.left": 0.71,
          "BOSTON.top": 0.43,
          "PERTH.left": 0.833,
          "PERTH.top": 0.42,
          "BORNEO.left": 0.833,
          "BORNEO.top": 0.42,
          "CHICAGO.left": 0.75,
          "CHICAGO.top": 0.5,
          "NICOSIA.left": 0.83,
          "NICOSIA.top": 0.44,
          "EDIMBURGO.left": 0.7,
          "EDIMBURGO.top": 0.41,
          "MEDELLIN.left": 0.6,
          "MEDELLIN.top": 0.4,
          "BARRANQUILLA.left": 0.71,
          "BARRANQUILLA.top": 0.43,
          "ANKARA.left": 0.55,
          "ANKARA.top": 0.48,
          MONTREALleft: 0.75,
          "MONTREAL.top": 0.42,
          "TORONTO.left": 0.6,
          "TORONTO.top": 0.41,
          "ATLANTA.left": 0.65,
          "ATLANTA.top": 0.5,
          "MIAMI.left": 0.32,
          "MIAMI.top": 0.47,
          "BAHIA.left": 0.32,
          "BAHIA.top": 0.47,
          "DALLAS.left": 0.74,
          "DALLAS.top": 0.42,
          "SIAN.left": 0.71,
          "SIAN.top": 0.43,
          "MINDANAO.left": 0.71,
          "MINDANAO.top": 0.43,
          "DELHI.left": 0.7,
          "DELHI.top": 0.41,
          "RABAT.left": 0.55,
          "RABAT.top": 0.45,
          "MONTREAL.left": 0.74,
          "MONTREAL.top_1": 0.42,
        },
        {
          grupo: "MEDIDAS",
          "QUITO.left": 0.7,
          "QUITO.top": 0.65,
          "RIMINI.left": 0.75,
          "RIMINI.top": 0.7,
          "JANEIRO.left": 0.77,
          "JANEIRO.top": 0.75,
          "SENNA.left": 0.6,
          "SENNA.top": 0.66,
          "BOGOTA.left": 0.18,
          "BOGOTA.top": 0.69,
          "DANUBIO.left": 0.78,
          "DANUBIO.top": 0.63,
          "ABUDABI.left": 0.8,
          "ABUDABI.top": 0.65,
          "CANCUN.left": 0.8,
          "CANCUN.top": 0.65,
          "FLORIDA.left": 0.7,
          "FLORIDA.top": 0.65,
          "GARONA.left": 0.8,
          "GARONA.top": 0.65,
          "GUADIANA.left": 0.77,
          "GUADIANA.top": 0.75,
          "IGUAZU.left": 0.78,
          "IGUAZU.top": 0.63,
          "MISURI.left": 0.6,
          "MISURI.top": 0.66,
          "ROMA.left": 0.7,
          "ROMA.top": 0.65,
          "VARSOVIA.left": 0.65,
          "VARSOVIA.top": 0.25,
          "VANCOUVER.left": 0.8,
          "VANCOUVER.top": 0.35,
          "QUEBEC.left": 0.6,
          "QUEBEC.top": 0.35,
          "LONDRES.left": 0.7,
          "LONDRES.top": 0.25,
          "SAOPAULO.left": 0.7,
          "SAOPAULO.top": 0.25,
          "PEKIN.left": 0.7,
          "PEKIN.top": 0.25,
          "RODAS.left": 0.4,
          "RODAS.top": 0.7,
          "ADELAIDA.left": 0.8,
          "ADELAIDA.top": 0.35,
          "CATANIA.left": 0.73,
          "CATANIA.top": 0.32,
          "TRENTO.left": 0.8,
          "TRENTO.top": 0.35,
          "MESINA.left": 0.66,
          "MESINA.top": 0.35,
          "POSITANO.left": 0.77,
          "POSITANO.top": 0.75,
          "NAZCA.left": 0.52,
          "NAZCA.top": 0.63,
          "CIXI.left": 0.66,
          "CIXI.top": 0.65,
          "YAKARTA.left": 0.8,
          "YAKARTA.top": 0.65,
          "BAGDAD.left": 0.7,
          "BAGDAD.top": 0.65,
          "KABUL.left": 0.7,
          "KABUL.top": 0.25,
          "KOBE.left": 0.77,
          "KOBE.top": 0.75,
          "BRUNEI.left": 0.7,
          "BRUNEI.top": 0.25,
          "SURIN.left": 0.7,
          "SURIN.top": 0.65,
          "NASSAU.left": 0.7,
          "NASSAU.top": 0.65,
          "BALI.left": 0.7,
          "BALI.top": 0.65,
          "SHANGHAI.left": 0.77,
          "SHANGHAI.top": 0.75,
          "ACAPULCO.left": 0.7,
          "ACAPULCO.top": 0.7,
          "DOHA.left": 0.4,
          "DOHA.top": 0.7,
          "FRANKFURT.left": 0.8,
          "FRANKFURT.top": 0.65,
          "ORLANDO.left": 0.18,
          "ORLANDO.top": 0.69,
          "BOSTON.left": 0.66,
          "BOSTON.top": 0.35,
          "PERTH.left": 0.7,
          "PERTH.top": 0.65,
          "BORNEO.left": 0.7,
          "BORNEO.top": 0.65,
          "CHICAGO.left": 0.8,
          "CHICAGO.top": 0.35,
          "NICOSIA.left": 0.78,
          "NICOSIA.top": 0.63,
          "EDIMBURGO.left": 0.78,
          "EDIMBURGO.top": 0.63,
          "MEDELLIN.left": 0.66,
          "MEDELLIN.top": 0.35,
          "BARRANQUILLA.left": 0.66,
          "BARRANQUILLA.top": 0.35,
          "ANKARA.left": 0.7,
          "ANKARA.top": 0.25,
          MONTREALleft: 0.8,
          "MONTREAL.top": 0.65,
          "TORONTO.left": 0.78,
          "TORONTO.top": 0.63,
          "ATLANTA.left": 0.65,
          "ATLANTA.top": 0.25,
          "MIAMI.left": 0.18,
          "MIAMI.top": 0.69,
          "BAHIA.left": 0.18,
          "BAHIA.top": 0.69,
          "DALLAS.left": 0.8,
          "DALLAS.top": 0.65,
          "SIAN.left": 0.66,
          "SIAN.top": 0.35,
          "MINDANAO.left": 0.66,
          "MINDANAO.top": 0.35,
          "DELHI.left": 0.78,
          "DELHI.top": 0.63,
          "RABAT.left": 0.73,
          "RABAT.top": 0.32,
          "MONTREAL.left": 0.8,
          "MONTREAL.top_1": 0.65,
        },
        {
          grupo: "REVESTIMIENTO",
          "QUITO.left": 0.4,
          "QUITO.top": 0.9,
          "RIMINI.left": 0.45,
          "RIMINI.top": 0.9,
          "JANEIRO.left": 0.39,
          "JANEIRO.top": 0.83,
          "SENNA.left": 0.72,
          "SENNA.top": 0.92,
          "BOGOTA.left": 0.43,
          "BOGOTA.top": 0.92,
          "DANUBIO.left": 0.5,
          "DANUBIO.top": 0.9,
          "ABUDABI.left": 0.75,
          "ABUDABI.top": 0.9,
          "CANCUN.left": 0.75,
          "CANCUN.top": 0.9,
          "FLORIDA.left": 0.45,
          "FLORIDA.top": 0.9,
          "GARONA.left": 0.75,
          "GARONA.top": 0.9,
          "GUADIANA.left": 0.39,
          "GUADIANA.top": 0.83,
          "IGUAZU.left": 0.53,
          "IGUAZU.top": 0.9,
          "MISURI.left": 0.72,
          "MISURI.top": 0.92,
          "ROMA.left": 0.45,
          "ROMA.top": 0.9,
          "VARSOVIA.left": 0.35,
          "VARSOVIA.top": 0.7,
          "VANCOUVER.left": 0.45,
          "VANCOUVER.top": 0.85,
          "QUEBEC.left": 0.4,
          "QUEBEC.top": 0.9,
          "LONDRES.left": 0.5,
          "LONDRES.top": 0.45,
          "SAOPAULO.left": 0.5,
          "SAOPAULO.top": 0.45,
          "PEKIN.left": 0.5,
          "PEKIN.top": 0.92,
          "RODAS.left": 0.4,
          "RODAS.top": 0.93,
          "ADELAIDA.left": 0.55,
          "ADELAIDA.top": 0.9,
          "CATANIA.left": 0.45,
          "CATANIA.top": 0.93,
          "TRENTO.left": 0.55,
          "TRENTO.top": 0.9,
          "MESINA.left": 0.55,
          "MESINA.top": 0.9,
          "POSITANO.left": 0.39,
          "POSITANO.top": 0.83,
          "NAZCA.left": 0.5,
          "NAZCA.top": 0.9,
          "CIXI.left": 0.4,
          "CIXI.top": 0.9,
          "YAKARTA.left": 0.75,
          "YAKARTA.top": 0.9,
          "BAGDAD.left": 0.45,
          "BAGDAD.top": 0.9,
          "KABUL.left": 0.35,
          "KABUL.top": 0.9,
          "KOBE.left": 0.39,
          "KOBE.top": 0.83,
          "BRUNEI.left": 0.46,
          "BRUNEI.top": 0.92,
          "SURIN.left": 0.45,
          "SURIN.top": 0.9,
          "NASSAU.left": 0.45,
          "NASSAU.top": 0.9,
          "BALI.left": 0.4,
          "BALI.top": 0.9,
          "SHANGHAI.left": 0.39,
          "SHANGHAI.top": 0.83,
          "ACAPULCO.left": 0.45,
          "ACAPULCO.top": 0.9,
          "DOHA.left": 0.4,
          "DOHA.top": 0.93,
          "FRANKFURT.left": 0.75,
          "FRANKFURT.top": 0.9,
          "ORLANDO.left": 0.43,
          "ORLANDO.top": 0.92,
          "BOSTON.left": 0.55,
          "BOSTON.top": 0.9,
          "PERTH.left": 0.45,
          "PERTH.top": 0.9,
          "BORNEO.left": 0.45,
          "BORNEO.top": 0.9,
          "CHICAGO.left": 0.45,
          "CHICAGO.top": 0.85,
          "NICOSIA.left": 0.5,
          "NICOSIA.top": 0.9,
          "EDIMBURGO.left": 0.5,
          "EDIMBURGO.top": 0.9,
          "MEDELLIN.left": 0.55,
          "MEDELLIN.top": 0.9,
          "BARRANQUILLA.left": 0.55,
          "BARRANQUILLA.top": 0.9,
          "ANKARA.left": 0.5,
          "ANKARA.top": 0.45,
          MONTREALleft: 0.75,
          "MONTREAL.top": 0.9,
          "TORONTO.left": 0.5,
          "TORONTO.top": 0.9,
          "ATLANTA.left": 0.35,
          "ATLANTA.top": 0.7,
          "MIAMI.left": 0.43,
          "MIAMI.top": 0.92,
          "BAHIA.left": 0.43,
          "BAHIA.top": 0.92,
          "DALLAS.left": 0.75,
          "DALLAS.top": 0.9,
          "SIAN.left": 0.55,
          "SIAN.top": 0.9,
          "MINDANAO.left": 0.55,
          "MINDANAO.top": 0.9,
          "DELHI.left": 0.5,
          "DELHI.top": 0.9,
          "RABAT.left": 0.45,
          "RABAT.top": 0.93,
          "MONTREAL.left": 0.75,
          "MONTREAL.top_1": 0.9,
        },
        {
          grupo: "ADICIONALES",
          "QUITO.left": 0.5465,
          "QUITO.top": 0.4825,
          "RIMINI.left": 0.7225,
          "RIMINI.top": 0.4725,
          "JANEIRO.left": 0.9025,
          "JANEIRO.top": 0.4825,
          "SENNA.left": 0.5825,
          "SENNA.top": 0.4825,
          "BOGOTA.left": 0.3725,
          "BOGOTA.top": 0.5225,
          "DANUBIO.left": 0.7525,
          "DANUBIO.top": 0.46249999999999997,
          "ABUDABI.left": 0.7,
          "ABUDABI.top": 0.75,
          "CANCUN.left": 0.7,
          "CANCUN.top": 0.75,
          "FLORIDA.left": 0.59,
          "FLORIDA.top": 0.4825,
          "GARONA.left": 0.7,
          "GARONA.top": 0.75,
          "GUADIANA.left": 0.78,
          "GUADIANA.top": 0.4825,
          "IGUAZU.left": 0.79,
          "IGUAZU.top": 0.46249999999999997,
          "MISURI.left": 0.5825,
          "MISURI.top": 0.4825,
          "ROMA.left": 0.6,
          "ROMA.top": 0.4825,
          "VARSOVIA.left": 0.8,
          "VARSOVIA.top": 0.4,
          "VANCOUVER.left": 0.85,
          "VANCOUVER.top": 0.65,
          "QUEBEC.left": 0.73,
          "QUEBEC.top": 0.65,
          "LONDRES.left": 0.82,
          "LONDRES.top": 0.65,
          "SAOPAULO.left": 0.82,
          "SAOPAULO.top": 0.65,
          "PEKIN.left": 0.82,
          "PEKIN.top": 0.65,
          "RODAS.left": 0.32,
          "RODAS.top": 0.46,
          "ADELAIDA.left": 0.85,
          "ADELAIDA.top": 0.65,
          "CATANIA.left": 0.85,
          "CATANIA.top": 0.65,
          "TRENTO.left": 0.85,
          "TRENTO.top": 0.65,
          "MESINA.left": 0.7,
          "MESINA.top": 0.65,
          "POSITANO.left": 0.9025,
          "POSITANO.top": 0.4825,
          "NAZCA.left": 0.7525,
          "NAZCA.top": 0.46249999999999997,
          "CIXI.left": 0.5465,
          "CIXI.top": 0.4825,
          "YAKARTA.left": 0.7,
          "YAKARTA.top": 0.75,
          "BAGDAD.left": 0.6,
          "BAGDAD.top": 0.4825,
          "KABUL.left": 0.82,
          "KABUL.top": 0.65,
          "KOBE.left": 0.9025,
          "KOBE.top": 0.4825,
          "BRUNEI.left": 0.82,
          "BRUNEI.top": 0.65,
          "SURIN.left": 0.6,
          "SURIN.top": 0.4825,
          "NASSAU.left": 0.59,
          "NASSAU.top": 0.4825,
          "BALI.left": 0.5465,
          "BALI.top": 0.4825,
          "SHANGHAI.left": 0.9025,
          "SHANGHAI.top": 0.4825,
          "ACAPULCO.left": 0.7225,
          "ACAPULCO.top": 0.4725,
          "DOHA.left": 0.32,
          "DOHA.top": 0.26,
          "FRANKFURT.left": 0.7,
          "FRANKFURT.top": 0.75,
          "ORLANDO.left": 0.3725,
          "ORLANDO.top": 0.5225,
          "BOSTON.left": 0.7,
          "BOSTON.top": 0.65,
          "PERTH.left": 0.59,
          "PERTH.top": 0.4825,
          "BORNEO.left": 0.59,
          "BORNEO.top": 0.4825,
          "CHICAGO.left": 0.85,
          "CHICAGO.top": 0.65,
          "NICOSIA.left": 0.7525,
          "NICOSIA.top": 0.46249999999999997,
          "EDIMBURGO.left": 0.7525,
          "EDIMBURGO.top": 0.46249999999999997,
          "MEDELLIN.left": 0.7,
          "MEDELLIN.top": 0.65,
          "BARRANQUILLA.left": 0.7,
          "BARRANQUILLA.top": 0.65,
          "ANKARA.left": 0.82,
          "ANKARA.top": 0.65,
          MONTREALleft: 0.7,
          "MONTREAL.top": 0.75,
          "TORONTO.left": 0.7525,
          "TORONTO.top": 0.46249999999999997,
          "ATLANTA.left": 0.8,
          "ATLANTA.top": 0.4,
          "MIAMI.left": 0.3725,
          "MIAMI.top": 0.5225,
          "BAHIA.left": 0.3725,
          "BAHIA.top": 0.5225,
          "DALLAS.left": 0.7,
          "DALLAS.top": 0.75,
          "SIAN.left": 0.7,
          "SIAN.top": 0.65,
          "MINDANAO.left": 0.7,
          "MINDANAO.top": 0.65,
          "DELHI.left": 0.7525,
          "DELHI.top": 0.46249999999999997,
          "RABAT.left": 0.85,
          "RABAT.top": 0.65,
          "MONTREAL.left": 0.7,
          "MONTREAL.top_1": 0.75,
        },
        {
          grupo: "MONTAJE",
          "QUITO.left": 0.5465,
          "QUITO.top": 0.4825,
          "RIMINI.left": 0.7225,
          "RIMINI.top": 0.4725,
          "JANEIRO.left": 0.9025,
          "JANEIRO.top": 0.4825,
          "SENNA.left": 0.5825,
          "SENNA.top": 0.4825,
          "BOGOTA.left": 0.3725,
          "BOGOTA.top": 0.5225,
          "DANUBIO.left": 0.7525,
          "DANUBIO.top": 0.46249999999999997,
          "ABUDABI.left": 0.7,
          "ABUDABI.top": 0.75,
          "CANCUN.left": 0.7,
          "CANCUN.top": 0.75,
          "FLORIDA.left": 0.59,
          "FLORIDA.top": 0.4825,
          "GARONA.left": 0.7,
          "GARONA.top": 0.75,
          "GUADIANA.left": 0.78,
          "GUADIANA.top": 0.4825,
          "IGUAZU.left": 0.79,
          "IGUAZU.top": 0.46249999999999997,
          "MISURI.left": 0.5825,
          "MISURI.top": 0.4825,
          "ROMA.left": 0.6,
          "ROMA.top": 0.4825,
          "VARSOVIA.left": 0.8,
          "VARSOVIA.top": 0.4,
          "VANCOUVER.left": 0.85,
          "VANCOUVER.top": 0.65,
          "QUEBEC.left": 0.73,
          "QUEBEC.top": 0.65,
          "LONDRES.left": 0.82,
          "LONDRES.top": 0.65,
          "SAOPAULO.left": 0.82,
          "SAOPAULO.top": 0.65,
          "PEKIN.left": 0.82,
          "PEKIN.top": 0.65,
          "RODAS.left": 0.32,
          "RODAS.top": 0.46,
          "ADELAIDA.left": 0.85,
          "ADELAIDA.top": 0.65,
          "CATANIA.left": 0.85,
          "CATANIA.top": 0.65,
          "TRENTO.left": 0.85,
          "TRENTO.top": 0.65,
          "MESINA.left": 0.7,
          "MESINA.top": 0.65,
          "POSITANO.left": 0.9025,
          "POSITANO.top": 0.4825,
          "NAZCA.left": 0.7525,
          "NAZCA.top": 0.46249999999999997,
          "CIXI.left": 0.5465,
          "CIXI.top": 0.4825,
          "YAKARTA.left": 0.7,
          "YAKARTA.top": 0.75,
          "BAGDAD.left": 0.6,
          "BAGDAD.top": 0.4825,
          "KABUL.left": 0.82,
          "KABUL.top": 0.65,
          "KOBE.left": 0.9025,
          "KOBE.top": 0.4825,
          "BRUNEI.left": 0.82,
          "BRUNEI.top": 0.65,
          "SURIN.left": 0.6,
          "SURIN.top": 0.4825,
          "NASSAU.left": 0.59,
          "NASSAU.top": 0.4825,
          "BALI.left": 0.5465,
          "BALI.top": 0.4825,
          "SHANGHAI.left": 0.9025,
          "SHANGHAI.top": 0.4825,
          "ACAPULCO.left": 0.7225,
          "ACAPULCO.top": 0.4725,
          "DOHA.left": 0.32,
          "DOHA.top": 0.26,
          "FRANKFURT.left": 0.7,
          "FRANKFURT.top": 0.75,
          "ORLANDO.left": 0.3725,
          "ORLANDO.top": 0.5225,
          "BOSTON.left": 0.7,
          "BOSTON.top": 0.65,
          "PERTH.left": 0.59,
          "PERTH.top": 0.4825,
          "BORNEO.left": 0.59,
          "BORNEO.top": 0.4825,
          "CHICAGO.left": 0.85,
          "CHICAGO.top": 0.65,
          "NICOSIA.left": 0.7525,
          "NICOSIA.top": 0.46249999999999997,
          "EDIMBURGO.left": 0.7525,
          "EDIMBURGO.top": 0.46249999999999997,
          "MEDELLIN.left": 0.7,
          "MEDELLIN.top": 0.65,
          "BARRANQUILLA.left": 0.7,
          "BARRANQUILLA.top": 0.65,
          "ANKARA.left": 0.82,
          "ANKARA.top": 0.65,
          MONTREALleft: 0.7,
          "MONTREAL.top": 0.75,
          "TORONTO.left": 0.7525,
          "TORONTO.top": 0.46249999999999997,
          "ATLANTA.left": 0.8,
          "ATLANTA.top": 0.4,
          "MIAMI.left": 0.3725,
          "MIAMI.top": 0.5225,
          "BAHIA.left": 0.3725,
          "BAHIA.top": 0.5225,
          "DALLAS.left": 0.7,
          "DALLAS.top": 0.75,
          "SIAN.left": 0.7,
          "SIAN.top": 0.65,
          "MINDANAO.left": 0.7,
          "MINDANAO.top": 0.65,
          "DELHI.left": 0.7525,
          "DELHI.top": 0.46249999999999997,
          "RABAT.left": 0.85,
          "RABAT.top": 0.65,
          "MONTREAL.left": 0.7,
          "MONTREAL.top_1": 0.75,
        },
        {
          "MONTREAL.left": "VIDRIO",
        },
        {
          "MONTREAL.left": "PERFIL",
        },
        {
          "MONTREAL.left": "TIRADOR",
        },
        {
          "MONTREAL.left": "MEDIDAS",
        },
        {
          "MONTREAL.left": "REVESTIMIENTO",
        },
        {
          "MONTREAL.left": "ADICIONALES",
        },
      ],
      objectPosition: [
        {
          coleccion: "QUITO",
          open: 1,
          close: 0.72,
        },
        {
          coleccion: "JANEIRO",
          open: 1,
          close: 0.89,
        },
        {
          coleccion: "BOGOTA",
          open: 0,
          close: 0.22,
        },
        {
          coleccion: "DANUBIO",
          open: 1,
          close: 0.77,
        },
        {
          coleccion: "RIMINI",
          open: 1,
          close: 0.89,
        },
        {
          coleccion: "SENNA",
          open: 1,
          close: 0.71,
        },
        {
          coleccion: "ABUDABI",
          open: 1,
          close: 0.83,
        },
        {
          coleccion: "CANCUN",
          open: 1,
          close: 0.85,
        },
        {
          coleccion: "FLORIDA",
          open: 1,
          close: 0.77,
        },
        {
          coleccion: "GARONA",
          open: 1,
          close: 0.79,
        },
        {
          coleccion: "GUADIANA",
          open: 1,
          close: 0.82,
        },
        {
          coleccion: "IGUAZU",
          open: 1,
          close: 0.8,
        },
        {
          coleccion: "MISURI",
          open: 1,
          close: 0.74,
        },
        {
          coleccion: "ROMA",
          open: 1,
          close: 0.8,
        },
        {
          coleccion: "DELHI",
          open: 1,
          close: 0.8,
        },
        {
          coleccion: "EDIMBURGO",
          open: 1,
          close: 0.69,
        },
        {
          coleccion: "LONDRES",
          open: 1,
          close: 0.77,
        },
        {
          coleccion: "MIAMI",
          open: 1,
          close: 0.37,
        },
        {
          coleccion: "QUEBEC",
          open: 1,
          close: 0.65,
        },
        {
          coleccion: "RABAT",
          open: 1,
          close: 0.71,
        },
        {
          coleccion: "VANCOUVER",
          open: 1,
          close: 0.77,
        },
        {
          coleccion: "VARSOVIA",
          open: 1,
          close: 0.73,
        },
        {
          coleccion: "SAOPAULO",
          open: 1,
          close: 0.67,
        },
        {
          coleccion: "PEKIN",
          open: 1,
          close: 0.77,
        },
        {
          coleccion: "RODAS",
          open: 1,
          close: 0.3,
        },
        {
          coleccion: "ADELAIDA",
          open: 1,
          close: 0.79,
        },
        {
          coleccion: "CATANIA",
          open: 1,
          close: 0.75,
        },
        {
          coleccion: "TRENTO",
          open: 1,
          close: 0.8,
        },
        {
          coleccion: "POSITANO",
          open: 1,
          close: 0.81,
        },
        {
          coleccion: "MESINA",
          open: 1,
          close: 0.68,
        },
        {
          coleccion: "TRENTO",
          open: 1,
          close: 0.72,
        },
        {
          coleccion: "NAZCA",
          open: 1,
          close: 0.54,
        },
        {
          coleccion: "CIXI",
          open: 1,
          close: 0.71,
        },
        {
          coleccion: "YAKARTA",
          open: 1,
          close: 0.82,
        },
        {
          coleccion: "BAGDAD",
          open: 1,
          close: 0.79,
        },
        {
          coleccion: "KABUL",
          open: 1,
          close: 0.75,
        },
        {
          coleccion: "KOBE",
          open: 1,
          close: 0.89,
        },
        {
          coleccion: "BRUNEI",
          open: 1,
          close: 0.8,
        },
        {
          coleccion: "SURIN",
          open: 1,
          close: 0.8,
        },
        {
          coleccion: "NASSAU",
          open: 1,
          close: 0.77,
        },
        {
          coleccion: "BALI",
          open: 1,
          close: 0.71,
        },
        {
          coleccion: "SHANGHAI",
          open: 1,
          close: 0.89,
        },
        {
          coleccion: "ACAPULCO",
          open: 1,
          close: 0.72,
        },
        {
          coleccion: "DOHA",
          open: 1,
          close: 0.3,
        },
        {
          coleccion: "FRANKFURT",
          open: 1,
          close: 0.8,
        },
        {
          coleccion: "MINDANAO",
          open: 1,
          close: 0.78,
        },
        {
          coleccion: "ORLANDO",
          open: 1,
          close: 0.34,
        },
        {
          coleccion: "ATLANTA",
          open: 1,
          close: 0.79,
        },
        {
          coleccion: "BAHIA",
          open: 1,
          close: 0.34,
        },
        {
          coleccion: "BOSTON",
          open: 1,
          close: 0.77,
        },
        {
          coleccion: "SUVA",
          open: 1,
        },
        {
          coleccion: "DALLAS",
          open: 1,
          close: 0.83,
        },
        {
          coleccion: "PERTH",
          open: 1,
          close: 0.83,
        },
        {
          coleccion: "BORNEO",
          open: 1,
          close: 0.82,
        },
        {
          coleccion: "SIAM",
          open: 1,
        },
        {
          coleccion: "CHICAGO",
          open: 1,
          close: 0.74,
        },
        {
          coleccion: "NICOSIA",
          open: 1,
          close: 0.84,
        },
        {
          coleccion: "MEDELLIN",
          open: 1,
          close: 0.71,
        },
        {
          coleccion: "BARANQUILLA",
          open: 1,
        },
        {
          coleccion: "ANKARA",
          open: 1,
          close: 0.78,
        },
        {
          coleccion: "MONTREAL",
          open: 1,
          close: 0.81,
        },
        {
          coleccion: "TORONTO",
          open: 1,
          close: 0.66,
        },
      ],
      estandar: [
        {
          campo: "ALTURA",
          estandar: "altura",
        },
        {
          campo: "COLOR_PERFIL_ST",
          estandar: "perfil",
        },
        {
          campo: "DECORADO",
          estandar: "vidrio",
        },
        {
          campo: "POMO_ST",
          estandar: "tirador",
        },
        {
          campo: "POSICION_HOJA_FIJA",
          estandar: "posicionFijo",
        },
        {
          campo: "COGIDA_PARED",
          estandar: "posicionFijo",
        },
        {
          campo: "POS_F_FRONTAL_ST",
          estandar: "posicionFijo",
        },
        {
          campo: "POS_F_LATERAL_ST",
          estandar: "posicionFijo",
        },
        {
          campo: "COGIDA_PARED",
          estandar: "posicionFijo",
        },
        {
          campo: "COGIDA",
          estandar: "posicionFijo",
        },
        {
          campo: "COGIDA_FIJO",
          estandar: "posicionFijo",
        },
        {
          campo: "MEDIDAS",
          estandar: "frontal",
        },
      ],
      tipoCampo: [
        {
          campo: "ANTICAL",
          tipo: "toggle",
        },
        {
          campo: "LATERAL_FIJO",
          tipo: "toggle",
        },
        {
          campo: "PERFIL_ESCUADRA",
          tipo: "tacos",
        },
        {
          campo: "SISTEMA_SUJECCION",
          tipo: "tacos",
        },
        {
          campo: "PERFILERIA_ECO",
          tipo: "tacos",
        },
      ],
    };
  }
}
